// extracted by mini-css-extract-plugin
export default {"root":"YAONq_YAONq","open":"zeNcl_zeNcl","navigation":"mK9MG_mK9MG","absBtn":"xF4Xe_xF4Xe"};